import { HFlow, Radio, Theme, useTheme, VFlow } from 'bold-ui'
import { HLabel } from 'components/HLabel'
import { Cns, Cpf } from 'components/label'
import { css } from 'emotion'
import { formatDate } from 'util/date/formatDate'

import { CidadaoDocumentoRepetidoArray } from './ModalCidadaosDocumentoRepetidos'

type CidadaoDocumentoRepetidoModel = CidadaoDocumentoRepetidoArray[0]

interface CidadaoDocumentoRepetidoCardProps {
  readonly cidadao: CidadaoDocumentoRepetidoModel
  readonly isSelected: boolean
  onSelectCidadao(): void
}

export const CidadaoDocumentoRepetidoCard = (props: CidadaoDocumentoRepetidoCardProps) => {
  const { cidadao, isSelected, onSelectCidadao } = props

  const theme = useTheme()
  const styles = createStyles(theme)

  return (
    <HFlow style={styles.container} onClick={onSelectCidadao}>
      <Radio checked={isSelected} readOnly={true} label='' />
      <VFlow vSpacing={0}>
        <HLabel title='Nome'>{cidadao?.nome?.titleCase()}</HLabel>
        {cidadao?.nomeSocial && <HLabel title='Nome Social'>{cidadao?.nomeSocial?.titleCase()}</HLabel>}
        <HFlow>
          <HLabel title='CPF'>
            <Cpf value={cidadao?.cpf} />
          </HLabel>
          <HLabel title='Nº NIS (PIS/PASEP)'>{cidadao?.nisPisPasep}</HLabel>
        </HFlow>
        <HFlow>
          <HLabel title='CNS'>
            <Cns value={cidadao?.cns} />
          </HLabel>
          <HLabel title='DNV'>{cidadao?.numeroDnv}</HLabel>
        </HFlow>
        <HFlow>
          <HLabel title='Data de Nascimento'>{cidadao?.dataNascimento && formatDate(cidadao?.dataNascimento)}</HLabel>
          <HLabel title='Sexo'>{cidadao?.sexo?.titleCase()}</HLabel>
        </HFlow>
        <HLabel title='Nome da mãe'>{cidadao?.nomeMae?.titleCase()}</HLabel>
        <HLabel title='Município de nascimento'>
          {cidadao?.localidadeNascimento &&
            `${cidadao?.localidadeNascimento?.nome?.titleCase()} - ${cidadao?.localidadeNascimento?.uf?.sigla}`}
        </HLabel>
        <VFlow
          style={css`
            margin-top: '0.5rem';
          `}
          vSpacing={0}
        >
          <HLabel title='Unidade de Saúde'>{cidadao?.cidadaoVinculacaoEquipe?.unidadeSaude?.nome}</HLabel>
          <HLabel title='Equipe'>
            {[cidadao?.cidadaoVinculacaoEquipe?.equipe?.nome, cidadao?.cidadaoVinculacaoEquipe?.equipe?.ine]
              .filter(Boolean)
              .join(' - ')}
          </HLabel>
          <HLabel title='Atualizado em'>{cidadao?.dataAtualizado && formatDate(cidadao?.dataAtualizado)}</HLabel>
        </VFlow>
      </VFlow>
    </HFlow>
  )
}

const createStyles = (theme: Theme) => ({
  container: css`
    border: ${`1px solid ${theme.pallete.gray.c70}`};
    padding: 1rem;
    border-radius: 2px;
  `,
})
